import React from 'react'
import GoogleAds from './GoogleAds'

interface AdContainerProps {
  position: 'header' | 'sidebar' | 'content' | 'footer'
  adSlot: string
  className?: string
}

const AdContainer: React.FC<AdContainerProps> = ({ position, adSlot, className = '' }) => {
  const getAdStyles = () => {
    switch (position) {
      case 'header':
        return {
          className: `w-full max-w-4xl mx-auto mb-8 ${className}`,
          adFormat: 'horizontal' as const,
          style: { minHeight: '90px', width: '100%' }
        }
      case 'sidebar':
        return {
          className: `w-full max-w-xs ${className}`,
          adFormat: 'vertical' as const,
          style: { minHeight: '250px', width: '300px' }
        }
      case 'content':
        return {
          className: `w-full max-w-2xl mx-auto my-8 ${className}`,
          adFormat: 'rectangle' as const,
          style: { minHeight: '250px', width: '100%' }
        }
      case 'footer':
        return {
          className: `w-full max-w-4xl mx-auto mt-8 ${className}`,
          adFormat: 'horizontal' as const,
          style: { minHeight: '90px', width: '100%' }
        }
      default:
        return {
          className: `w-full ${className}`,
          adFormat: 'auto' as const,
          style: { minHeight: '100px' }
        }
    }
  }

  const { className: adClassName, adFormat, style } = getAdStyles()

  return (
    <div className={`ad-container border border-gray-200 rounded-lg p-4 bg-gray-50/50 ${adClassName}`}>
      <GoogleAds
        adSlot={adSlot}
        adFormat={adFormat}
        style={style}
        className="mx-auto"
      />
    </div>
  )
}

export default AdContainer
